<template lang="pug">
  .b-change
    BasePriority._item.old(:level="change.info.old")
    BasePriority._item(:level="change.info.new")
</template>

<script>
import BasePriority from '@/components/BasePriority.vue';

export default {
  name: 'TaskChangePriority',
  components: { BasePriority },
  props: {
    change: Object,
  },
};
</script>

<style scoped lang="scss">
  .change {
    display: flex;
    gap: 18px;

    &__item {
      height: 20px;
    }
  }
</style>
